import { sendClientRequest } from '@/utils/client-request'

import { shopperHeaders as buildHeaders, type Shopper as Ctx } from './shopper-headers'

export const fetchCartApi = (ctx: Ctx) =>
  sendClientRequest({ url: '/cart', auth: false, headers: buildHeaders(ctx) })

export const postCartProducts = (ctx: Ctx, products: any[]) =>
  sendClientRequest({ url: '/cart', method: 'POST', auth: false, headers: buildHeaders(ctx), body: { products } })

export const deleteCartApi = (ctx: Ctx, cartId: string) =>
  sendClientRequest({ url: `/cart/${cartId}`, method: 'DELETE', auth: false, headers: buildHeaders(ctx) })

export const validateCartApi = (vendorId: string, products: any[], cartId?: string) =>
  sendClientRequest({
    url: '/cart/validate',
    method: 'POST',
    auth: false,
    headers: { Vendor: vendorId } as any,
    body: { products: products.map(({ discounts, ...product }) => product), cartId },
  })

export const fetchCartRecommendationsApi = (vendorId: string, categoryIds: string[], excludeProductIds: string[], limit = 5) =>
  sendClientRequest({
    url: '/products/cart-recommendations',
    method: 'POST',
    auth: false,
    headers: { Vendor: vendorId } as any,
    body: { categoryIds, excludeProductIds, limit },
  })
